import { RootState } from "../../../../../store/root.reducer";
import { getSSProfiles } from "../../../../../store/root.selectors";

export const getSSProfilesSavedList = (state: RootState) =>
  getSSProfiles(state).saved.list;

export const getSSProfilesChangedList = (state: RootState) =>
  getSSProfiles(state).changed.list;
